(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aguacate-drop-window"] && !Shopify.designMode) return;
  try {
    
/**
 * Cuenta atras hasta el cierre de la ventana.
 * La fecha ya esta en el HTML como <time>: esto es enfasis, no el dato.
 * Si el JS falla o la fecha no parsea, el bloque se oculta y la fecha en
 * texto sigue ahi.
 */
(function () {
  document.querySelectorAll('[data-am-countdown]').forEach(function (el) {
    var deadline = Date.parse(el.dataset.deadline);
    if (isNaN(deadline)) { el.hidden = true; return; }

    var units = {};
    el.querySelectorAll('[data-unit]').forEach(function (n) { units[n.dataset.unit] = n; });

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var left = Math.max(0, deadline - Date.now());
      var s = Math.floor(left / 1000);
      if (units.d) units.d.textContent = pad(Math.floor(s / 86400));
      if (units.h) units.h.textContent = pad(Math.floor((s % 86400) / 3600));
      if (units.m) units.m.textContent = pad(Math.floor((s % 3600) / 60));
      if (units.s) units.s.textContent = pad(s % 60);
      if (left === 0 && timer) clearInterval(timer);
    }

    tick();
    var timer = setInterval(tick, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
